import httpClient, { isHttpError } from '../httpClient';

export async function getPlanoTrabalhoTed(id: string) {
  try {
    console.log('id', id);
    const response = await httpClient.get(`/api/ted-plano-trabalho/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllPlanosTrabalhoTed() {
  try {
    const response = await httpClient.get(`/api/ted-plano-trabalho`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getPlanosTrabalhoPorPlanoAcao(id: string) {
  try {
    const response = await httpClient.get(
      `/api/ted-plano-trabalho/ted-plano-acao/${id}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}

export async function createPlanoTrabalho(PlanoData: any) {
  try {
    const response = await httpClient.post(
      `/api/ted-plano-trabalho`,
      PlanoData,
    );
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao salvar o plano de trabalho.',
      );
    }
    throw error;
  }
}

export const updatePlanoTrabalho = async (
  id: string,
  data: any,
): Promise<any> => {
  try {
    const response = await httpClient.patch(
      `/api/ted-plano-trabalho/${id}`,
      data,
    );
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message ||
          'Erro ao atualizar o plano de trabalho.',
      );
    }
    throw error;
  }
};

export const deleteDeletePlanoTrabalho = async (id: string): Promise<any> => {
  try {
    const response = await httpClient.delete(`/api/ted-plano-trabalho/${id}`);
    return response;
  } catch (error) {
    if (isHttpError(error)) {
      throw new Error(
        error.response?.data?.message || 'Erro ao deletar o plano de trabalho.',
      );
    }
    throw error;
  }
};
